import {isEmpty} from 'lodash'
import React, {useCallback, useState} from 'react'
import {useIntl} from 'react-intl'
import {toast} from 'react-toastify'
import useCancelToken from '../../../../../../_gori/hooks/UseCancelToken'
import {Button, ConfirmActionSwal, TableHeader} from '../../../../../../_gori/partials/widgets'
import SettingsService from '../../../core/_requests'

type Props = {
  selectedListId?: any
  reloadTable: any
}

const ShippingAddressFilter: React.FC<Props> = ({selectedListId, reloadTable}) => {
  const intl = useIntl()
  const {newCancelToken, isCancel} = useCancelToken()
  const [loadingRemove, setLoadingRemove] = useState(false)
  const [showModalConfirmDelete, setShowModalConfirmDelete] = useState(false)

  const handleDelete = useCallback(async () => {
    if (isEmpty(selectedListId)) return
    setLoadingRemove(true)
    const payload = {
      ids: selectedListId.map((item) => item.original.id),
    }

    try {
      const res = await SettingsService.deleteAddress(payload, {cancelToken: newCancelToken()})
      if (res.status) {
        reloadTable()
        toast.success(intl.formatMessage({id: 'DELETED_SUCCESSFULLY'}))
      }
    } catch (error) {
      if (isCancel(error)) return
      toast.error(intl.formatMessage({id: 'DELETED_FAILED'}))
    } finally {
      setLoadingRemove(false)
    }
  }, [intl, isCancel, newCancelToken, reloadTable, selectedListId])

  return (
    <>
      {showModalConfirmDelete && (
        <ConfirmActionSwal
          show={showModalConfirmDelete}
          title={intl.formatMessage({id: 'DELETE_ADDRESS'})}
          message={intl.formatMessage({id: 'ARE_YOU_SURE'})}
          messageCancel={intl.formatMessage({id: 'NO'})}
          handleCallBack={handleDelete}
          handleClose={() => setShowModalConfirmDelete(false)}
        />
      )}
      <TableHeader className='min-h-1px pb-3 d-flex flex-column'>
        <div className='card-toolbar flex-row-fluid justify-content-end align-items-start'>
          <div className={`d-flex align-items-center ${!(selectedListId.length > 0) && 'd-none'}`}>
            <div className='fw-bolder me-5'>
              <span className='me-2'>{selectedListId.length}</span>
              {intl.formatMessage({id: 'SELECTED'})}
            </div>
            <Button
              className='btn bg-light-danger bg-hover-danger text-danger text-hover-white fs-5 me-3'
              label={intl.formatMessage({id: 'REMOVE'})}
              loadingText={intl.formatMessage({id: 'REMOVE'})}
              event={() => setShowModalConfirmDelete(true)}
              loading={loadingRemove}
            />
          </div>
        </div>
      </TableHeader>
    </>
  )
}

export {ShippingAddressFilter}
